// ADDED: Hook for log generation logic
import { useState } from 'react';
import { employeeTimeRecordService } from '../services/employeeTimeRecordService';

export const useGenerateFixedLogs = () => {
  const [loading, setLoading] = useState(false);

  const generateLogs = async (employeeTypeId, dateFrom, dateTo, userId) => {
    setLoading(true);
    try {
      const result = await employeeTimeRecordService.generateFixedLogs({
        // employeeTypeId,
        // dateFrom,
        // dateTo,
        createdById: userId
      });
      return { success: true, message: result.message };
    } catch (error) {
      console.error(error);
      return { success: false, message: error.response?.data?.message || "Error generating logs" };
    } finally {
      setLoading(false);
    }
  };

  const generateFixedLogsByEmployee = async (employeePersonalInformationId, dateFrom, dateTo, userId) => {
    setLoading(true);
    try {
      const result = await employeeTimeRecordService.generateFixedLogsByEmployee({
        employeePersonalInformationId,
        dateFrom,
        dateTo,
        createdById: userId
      });
      return { success: true, message: result.message };
    } catch (error) {
      console.error(error);
      return { success: false, message: error.response?.data?.message || "Error generating logs" };
    } finally {
      setLoading(false);
    }
  };

  return { generateLogs, generateFixedLogsByEmployee, loading };
};